import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import StateTree from "../globalHelpers/StateTree";

class CustomerHelper {
    async fetchUser(callback) {
        try {
            const userId = window.sessionStorage.getItem("userId");

            if (userId && userId.length > 0) {
                const user = await Express.callAsync("fetch-user", {
                    userId: userId,
                });
                if (callback) {
                    callback(user);
                }
                return user;
            } else {
                const sessionId = Express.getSessionId();

                if (sessionId) {
                    const session = await Express.callAsync("fetch-session", {
                        sessionId,
                    });
                    let user = null;

                    if (session && session.userId) {
                        user = {};
                        user = await Express.callAsync("fetch-user", {
                            userId: session.userId,
                        });

                        if (!window.sessionStorage.getItem("agentUserId")) {
                            window.sessionStorage.setItem(
                                "userId",
                                session.userId
                            );
                        }
                    }

                    if (callback) {
                        callback(user);
                    }
                    return user;
                } else {
                    return null;
                }
            }
        } catch (e) {
            console.log(e);
            if (callback) {
                callback(null);
            }
            return null;
        }
    }

    async fetchUserId(callback) {
        let userId = window.sessionStorage.getItem("userId");

        if (userId) {
            if (callback) {
                callback(userId);
            }
            return userId;
        } else {
            const sessionId = Express.getSessionId();

            if (sessionId) {
                const session = await Express.callAsync("fetch-session", {
                    sessionId,
                });

                if (session && session.userId) {
                    userId = session.userId;
                    if (!window.sessionStorage.getItem("agentUserId")) {
                        window.sessionStorage.setItem("userId", session.userId);
                    }
                }

                if (callback) {
                    callback(userId);
                }
                return userId;
            } else {
                return null;
            }
        }
    }

    async fetchSession(callback) {
        try {
            const sessionId = Express.getSessionId();

            if (sessionId) {
                const session = await Express.callAsync("fetch-session", {
                    sessionId,
                });

                if (session && session.customerDataMap) {
                    const keys = Object.keys(session.customerDataMap);

                    for (let i = 0; i < keys.length; i++) {
                        const key = keys[i];
                        const sessionData = session.customerDataMap[key];
                        StateTree.update(key, sessionData);
                    }
                }

                if (callback) {
                    callback(session);
                }
            } else {
                if (callback) {
                    callback(null);
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    async fetchLockedStatus(callback, userId) {
        if (!userId) {
            this.fetchUser((user) => {
                if (callback && user) {
                    callback(user.locked);
                }
            });
        } else {
            Express.callPublic(
                "fetch-user-locked-status",
                { userId },
                (results) => {
                    if (callback) {
                        callback(results);
                    }
                }
            );
        }
    }

    async lockUser() {
        this.fetchUserId((userId) => {
            Express.call("lock-user", { userId });
        });
    }

    async unlockUser() {
        this.fetchUserId((userId) => {
            Express.call("unlock-user", { userId });
        });
    }

    async fetchAgentUserId(callback) {
        const userId = window.sessionStorage.getItem("agentUserId");

        if (callback) {
            callback(userId);
        }
        return userId;
    }

    async fetchAgentUser(callback) {
        const userId = await this.fetchAgentUserId();

        const user = await Express.callAsync("fetch-user", {
            userId: userId,
        });
        if (callback) {
            callback(user);
        }
        return user;
    }
}

export default new CustomerHelper();
